import { render } from "./HelpCatalogShow.vue?vue&type=template&id=d3c13ed8&scoped=true"
import script from "./HelpCatalogShow.vue?vue&type=script&lang=js"
export * from "./HelpCatalogShow.vue?vue&type=script&lang=js"

import "./HelpCatalogShow.vue?vue&type=style&index=0&id=d3c13ed8&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c13ed8"]])

export default __exports__